// doctor-patient-app/frontend/src/api/patientApi.js
import axios from 'axios';
import { SEALOS_HOSPITAL_API_URL } from './baseUrls';

// 设置基础 URL
const API_URL = SEALOS_HOSPITAL_API_URL;

// 获取患者信息的请求函数
export const getPatientInfo = async (name, keshi, hospital) => {
    try {
        const response = await axios.get(`${API_URL}/patient`, {
            params: {
                getflag: 'getall',
                name,
                keshi,
                hospital
            }
        });
        console.log('获取患者信息成功', response.data);

        return response.data; // 返回患者信息
    } catch (error) {
        console.error("获取患者信息失败:", error);
        throw error; // 抛出错误以便调用者处理
    }
};



// 编辑患者信息的请求函数
export const editPatientInfo = async (id, data) => {
    try {
        const response = await axios.post(`${API_URL}/patient`, {
            flag: 'edit',
            id,
            data

        });
        console.log('编辑患者信息成功', response.data);

        return response.data; // 返回患者信息
    } catch (error) {
        console.error("编辑患者信息失败:", error);
        throw error; // 抛出错误以便调用者处理
    }
};

// 删除患者信息的请求函数
export const deletePatientInfo = async (id) => {
    try {
        const response = await axios.post(`${API_URL}/patient`, {
            flag: 'delete',
            id
        });
        console.log('删除信息成功', response.data);

        return response.data; // 返回患者信息
    } catch (error) {
        console.error("删除患者信息失败:", error);
        throw error; // 抛出错误以便调用者处理
    }
};
